// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bd3z","right":"styles_right__3KBuL"};